//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  // Please make all SWYM-related API calls inside this function.
  // You can use the swat argument within this scope.
  if (swat) {
    const atcButtons = document.querySelectorAll('swym-storefront-layout-as-drawer [data-action="add-to-cart"]');

            // Function to process title elements
    const processTitleElements = (retryCount = 0, maxRetries = 5) => {
      const titleElements = document.querySelectorAll('.swym-storefront-layout-grid-item-title');
      let elementsWithoutHref = 0;

      titleElements.forEach(titleElement => {
        // Check if title element has href attribute
        const href = titleElement.getAttribute('href');

        if (href) {
          // Check if we already created a custom link for this element
          const existingCustomLink = titleElement.parentNode.querySelector('.custom-product-link');
          const nextSiblingIsCustomLink = titleElement.nextSibling && titleElement.nextSibling.classList?.contains('custom-product-link');

          if (existingCustomLink || nextSiblingIsCustomLink) {
            return;
          }

          // Create our own anchor element
          const newAnchor = document.createElement('a');
          newAnchor.href = href;
          newAnchor.textContent = 'View Product'; // You can customize this text
          newAnchor.className = 'custom-product-link'; // Add your own CSS class

          // Append the created element next to the title element
          titleElement.parentNode.insertBefore(newAnchor, titleElement.nextSibling);
        } else {
          elementsWithoutHref++;
        }
      });

      // If we found elements without href and haven't exceeded max retries, try again
      if (elementsWithoutHref > 0 && retryCount < maxRetries) {
        setTimeout(() => {
          processTitleElements(retryCount + 1, maxRetries);
        }, 1000);
      }
    };

    // Start processing
    processTitleElements();
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);